define("shared/components/shared/profile-categorization/categorize-steps/business-model", ["exports", "@ember/component", "@ember/object", "@ember/utils", "@glimmer/component", "@glimmer/tracking", "lodash", "@ember/template-factory"], function (_exports, _component, _object, _utils, _component2, _tracking, _lodash, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/utils",0,"@glimmer/component",0,"@glimmer/tracking",0,"lodash",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#if (eq this.currentStep "business-type")}}
    <p class="u--m__b__0 u--text--light u--text--center qa--categorize_title">
      {{t "profile_categorization.categorize_form.business_model.title"}}
    </p>
    <p class="u--text--light u--text--center">
      {{t "profile_categorization.categorize_form.business_model.subtitle"}}
    </p>
  
    <div class="o--formWrapper tOB--form__dropdown">
      <h2 class="tSC--card__title">
        {{t "profile_categorization.categorize_form.select_business_type" displayNickname=@displayNickname}}
      </h2>
  
      <span class="qa--categorize_business_model">
        {{#each @businessTypes as |businessType|}}
          <Shared::Ui::Button
            @additional="block"
            @onClick={{fn @chooseBusinessType businessType}}
            @size="regular"
            @variant="outline"
            class="qa--categorize_option tSC--btn"
            {{show-on-hover "e--icon--foward"}}
          >
            {{businessType.name}}
            {{svg-jar "arrow-right" class="o--icon u--float--right u--hide e--icon--foward u--fadeIn--left"}}
          </Shared::Ui::Button>
        {{/each}}
      </span>
    </div>
  
  {{/if}}
  
  {{#if (eq this.currentStep "questions")}}
    <p class="u--text--light u--text--center qa--categorize_title">
      {{t "profile_categorization.categorize_form.tell_us_about_profile" displayNickname=@displayNickname}}
    </p>
  
    <div class="o--formWrapper tOB--form__dropdown">
      <h2 class="tSC--card__title">{{this.currentQuestion.text}}</h2>
  
      <span class="qa--categorize_extra_question">
        {{#each this.currentQuestion.answers as |answer|}}
          <Shared::Ui::Button
            @additional="block"
            @onClick={{fn this.answerQuestion answer}}
            @size="regular"
            @variant="outline"
            class="qa--categorize_option tSC--btn"
            {{show-on-hover "toggle-forward-icon"}}
          >
            {{answer.text}}
            {{svg-jar "arrow-right" class="o--icon u--float--right u--hide toggle-forward-icon u--fadeIn--left"}}
          </Shared::Ui::Button>
        {{/each}}
      </span>
    </div>
  
  {{/if}}
  
  {{#if (eq this.currentStep "business-model")}}
    <p class="u--m__b__lg u--text--light u--text--center qa--categorize_title">
      {{t "profile_categorization.categorize_form.business_model.final_title"}}
    </p>
  
    <div
      class="o--formWrapper tOB--form__dropdown tOB--form__dropdown--description
        {{if (is-empty @finalBusinessModels) 'o--btn o--btn--primary'}}"
    >
      <h2 class="tSC--card__title">
        {{t "profile_categorization.categorize_form.select_business_model" displayNickname=@displayNickname}}
      </h2>
      <PowerSelect
        @onChange={{@chooseBusinessModel}}
        @onClose={{this.removeDescription}}
        @options={{@finalBusinessModels}}
        @placeholder={{t "shared_phrases.select_option"}}
        @renderInPlace={{true}}
        @searchEnabled={{false}}
        @selected={{@selectedBusinessModel}}
        @triggerId="qa--categorize_power_select_business"
        as |businessModel|
      >
  
        <p class="tOB--form__description">
          {{format-profile-categorization-value businessModel.name businessModel.keyword}}
        </p>
  
        {{#if businessModel.persona_definition}}
          <p class="tOB--form__description u--text--sm u--text--light business-model-description">
            {{businessModel.persona_definition}}
          </p>
        {{/if}}
  
      </PowerSelect>
  
      <div id="business-search-box">
        <Shared::ProfileCategorization::CategorizeSteps::SearchBox
          @inputValue={{@otherBusinessModel}}
          @isManualDrop={{true}}
          @onKeyupAction={{@searchOtherBusinessModel}}
          @onSelectAction={{@chooseBusinessModel}}
          @placeholder={{t "profile_categorization.categorize_form.other_business_model_placeholder"}}
          @searchResults={{@otherBusinessModelSearchResults}}
          @setCloseAction={{@setCloseAction}}
          @setOpenAction={{@setOpenAction}}
          @showSearchBox={{@otherBusinessModelSelected}}
        />
      </div>
    </div>
  
    <Shared::ProfileCategorization::CategorizeSteps::Persona @businessModel={{@selectedBusinessModel}} />
  {{/if}}
  
  <div class="o--btnBar">
    <Shared::Ui::Button
      @onClick={{this.goBack}}
      @size="regular"
      @variant="mute"
      class="u--float--left qa--categorize_back"
    >
      <span class="u--m__r__sm">
        {{svg-jar "arrow-left" class="o--icon"}}
      </span>
      {{t "shared_words.back"}}
    </Shared::Ui::Button>
  
    {{#if (eq this.currentStep "business-model")}}
      <Shared::Ui::Button
        @isDisabled={{not @isBusinessModelFormComplete}}
        @onClick={{@markBusinessModelSelectionComplete}}
        @size="regular"
        class="qa--categorize_continue u--float--right"
      >
        {{t "shared_words.continue"}}
        <span class="u--m__l__sm">
          {{svg-jar "arrow-right" class="o--icon"}}
        </span>
      </Shared::Ui::Button>
    {{/if}}
  </div>
  */
  {
    "id": "x0qBsPu6",
    "block": "[[[41,[28,[37,1],[[30,0,[\"currentStep\"]],\"business-type\"],null],[[[1,\"  \"],[10,2],[14,0,\"u--m__b__0 u--text--light u--text--center qa--categorize_title\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"profile_categorization.categorize_form.business_model.title\"],null]],[1,\"\\n  \"],[13],[1,\"\\n  \"],[10,2],[14,0,\"u--text--light u--text--center\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"profile_categorization.categorize_form.business_model.subtitle\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"o--formWrapper tOB--form__dropdown\"],[12],[1,\"\\n    \"],[10,\"h2\"],[14,0,\"tSC--card__title\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"profile_categorization.categorize_form.select_business_type\"],[[\"displayNickname\"],[[30,1]]]]],[1,\"\\n    \"],[13],[1,\"\\n\\n    \"],[10,1],[14,0,\"qa--categorize_business_model\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,2]],null]],null],null,[[[1,\"        \"],[8,[39,5],[[24,0,\"qa--categorize_option tSC--btn\"],[4,[38,7],[\"e--icon--foward\"],null]],[[\"@additional\",\"@onClick\",\"@size\",\"@variant\"],[\"block\",[28,[37,6],[[30,4],[30,3]],null],\"regular\",\"outline\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[30,3,[\"name\"]]],[1,\"\\n          \"],[1,[28,[35,8],[\"arrow-right\"],[[\"class\"],[\"o--icon u--float--right u--hide e--icon--foward u--fadeIn--left\"]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[3]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,1],[[30,0,[\"currentStep\"]],\"questions\"],null],[[[1,\"  \"],[10,2],[14,0,\"u--text--light u--text--center qa--categorize_title\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"profile_categorization.categorize_form.tell_us_about_profile\"],[[\"displayNickname\"],[[30,1]]]]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[14,0,\"o--formWrapper tOB--form__dropdown\"],[12],[1,\"\\n    \"],[10,\"h2\"],[14,0,\"tSC--card__title\"],[12],[1,[30,0,[\"currentQuestion\",\"text\"]]],[13],[1,\"\\n\\n    \"],[10,1],[14,0,\"qa--categorize_extra_question\"],[12],[1,\"\\n\"],[42,[28,[37,4],[[28,[37,4],[[30,0,[\"currentQuestion\",\"answers\"]]],null]],null],null,[[[1,\"        \"],[8,[39,5],[[24,0,\"qa--categorize_option tSC--btn\"],[4,[38,7],[\"toggle-forward-icon\"],null]],[[\"@additional\",\"@onClick\",\"@size\",\"@variant\"],[\"block\",[28,[37,6],[[30,0,[\"answerQuestion\"]],[30,5]],null],\"regular\",\"outline\"]],[[\"default\"],[[[[1,\"\\n          \"],[1,[30,5,[\"text\"]]],[1,\"\\n          \"],[1,[28,[35,8],[\"arrow-right\"],[[\"class\"],[\"o--icon u--float--right u--hide toggle-forward-icon u--fadeIn--left\"]]]],[1,\"\\n        \"]],[]]]]],[1,\"\\n\"]],[5]],null],[1,\"    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n\"]],[]],null],[1,\"\\n\"],[41,[28,[37,1],[[30,0,[\"currentStep\"]],\"business-model\"],null],[[[1,\"  \"],[10,2],[14,0,\"u--m__b__lg u--text--light u--text--center qa--categorize_title\"],[12],[1,\"\\n    \"],[1,[28,[35,2],[\"profile_categorization.categorize_form.business_model.final_title\"],null]],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[10,0],[15,0,[29,[\"o--formWrapper tOB--form__dropdown tOB--form__dropdown--description\\n      \",[52,[28,[37,9],[[30,6]],null],\"o--btn o--btn--primary\"]]]],[12],[1,\"\\n    \"],[10,\"h2\"],[14,0,\"tSC--card__title\"],[12],[1,\"\\n      \"],[1,[28,[35,2],[\"profile_categorization.categorize_form.select_business_model\"],[[\"displayNickname\"],[[30,1]]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[8,[39,10],null,[[\"@onChange\",\"@onClose\",\"@options\",\"@placeholder\",\"@renderInPlace\",\"@searchEnabled\",\"@selected\",\"@triggerId\"],[[30,7],[30,0,[\"removeDescription\"]],[30,6],[28,[37,2],[\"shared_phrases.select_option\"],null],true,false,[30,8],\"qa--categorize_power_select_business\"]],[[\"default\"],[[[[1,\"\\n\\n      \"],[10,2],[14,0,\"tOB--form__description\"],[12],[1,\"\\n        \"],[1,[28,[35,11],[[30,9,[\"name\"]],[30,9,[\"keyword\"]]],null]],[1,\"\\n      \"],[13],[1,\"\\n\\n\"],[41,[30,9,[\"persona_definition\"]],[[[1,\"        \"],[10,2],[14,0,\"tOB--form__description u--text--sm u--text--light business-model-description\"],[12],[1,\"\\n          \"],[1,[30,9,[\"persona_definition\"]]],[1,\"\\n        \"],[13],[1,\"\\n\"]],[]],null],[1,\"\\n    \"]],[9]]]]],[1,\"\\n\\n    \"],[10,0],[14,1,\"business-search-box\"],[12],[1,\"\\n      \"],[8,[39,12],null,[[\"@inputValue\",\"@isManualDrop\",\"@onKeyupAction\",\"@onSelectAction\",\"@placeholder\",\"@searchResults\",\"@setCloseAction\",\"@setOpenAction\",\"@showSearchBox\"],[[30,10],true,[30,11],[30,7],[28,[37,2],[\"profile_categorization.categorize_form.other_business_model_placeholder\"],null],[30,12],[30,13],[30,14],[30,15]]],null],[1,\"\\n    \"],[13],[1,\"\\n  \"],[13],[1,\"\\n\\n  \"],[8,[39,13],null,[[\"@businessModel\"],[[30,8]]],null],[1,\"\\n\"]],[]],null],[1,\"\\n\"],[10,0],[14,0,\"o--btnBar\"],[12],[1,\"\\n  \"],[8,[39,5],[[24,0,\"u--float--left qa--categorize_back\"]],[[\"@onClick\",\"@size\",\"@variant\"],[[30,0,[\"goBack\"]],\"regular\",\"mute\"]],[[\"default\"],[[[[1,\"\\n    \"],[10,1],[14,0,\"u--m__r__sm\"],[12],[1,\"\\n      \"],[1,[28,[35,8],[\"arrow-left\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n    \"],[13],[1,\"\\n    \"],[1,[28,[35,2],[\"shared_words.back\"],null]],[1,\"\\n  \"]],[]]]]],[1,\"\\n\\n\"],[41,[28,[37,1],[[30,0,[\"currentStep\"]],\"business-model\"],null],[[[1,\"    \"],[8,[39,5],[[24,0,\"qa--categorize_continue u--float--right\"]],[[\"@isDisabled\",\"@onClick\",\"@size\"],[[28,[37,14],[[30,16]],null],[30,17],\"regular\"]],[[\"default\"],[[[[1,\"\\n      \"],[1,[28,[35,2],[\"shared_words.continue\"],null]],[1,\"\\n      \"],[10,1],[14,0,\"u--m__l__sm\"],[12],[1,\"\\n        \"],[1,[28,[35,8],[\"arrow-right\"],[[\"class\"],[\"o--icon\"]]]],[1,\"\\n      \"],[13],[1,\"\\n    \"]],[]]]]],[1,\"\\n\"]],[]],null],[13]],[\"@displayNickname\",\"@businessTypes\",\"businessType\",\"@chooseBusinessType\",\"answer\",\"@finalBusinessModels\",\"@chooseBusinessModel\",\"@selectedBusinessModel\",\"businessModel\",\"@otherBusinessModel\",\"@searchOtherBusinessModel\",\"@otherBusinessModelSearchResults\",\"@setCloseAction\",\"@setOpenAction\",\"@otherBusinessModelSelected\",\"@isBusinessModelFormComplete\",\"@markBusinessModelSelectionComplete\"],false,[\"if\",\"eq\",\"t\",\"each\",\"-track-array\",\"shared/ui/button\",\"fn\",\"show-on-hover\",\"svg-jar\",\"is-empty\",\"power-select\",\"format-profile-categorization-value\",\"shared/profile-categorization/categorize-steps/search-box\",\"shared/profile-categorization/categorize-steps/persona\",\"not\"]]",
    "moduleName": "shared/components/shared/profile-categorization/categorize-steps/business-model.hbs",
    "isStrictMode": false
  });
  let BusinessModelComponent = _exports.default = (_class = class BusinessModelComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "questionHistory", _descriptor, this);
    }
    get isOnFirstQuestion() {
      return (0, _utils.isEmpty)(this.previousQuestion);
    }
    get previousQuestion() {
      return this.questionHistory.slice(-1)[0];
    }
    get currentQuestion() {
      if ((0, _lodash.isEmpty)(this.args.validQuestions)) {
        return null;
      }
      return this.args.validQuestions.find(_ref => {
        let {
          isAnswered
        } = _ref;
        return !isAnswered;
      });
    }
    get currentStep() {
      if (!this.args.isBusinessTypeStepComplete) {
        return 'business-type';
      } else if ((0, _utils.isPresent)(this.args.validQuestions) && (0, _utils.isPresent)(this.currentQuestion)) {
        return 'questions';
      }
      return 'business-model';
    }
    get previousDropdownStep() {
      switch (this.currentStep) {
        case 'business-type':
          return null;
        case 'questions':
          return this.isOnFirstQuestion ? 'business-type' : 'questions';
        case 'business-model':
          return 'questions';
        default:
          return null;
      }
    }
    get isContinueDisabled() {
      switch (this.currentStep) {
        case 'business-type':
          return (0, _lodash.isEmpty)(this.args.selectedBusinessType);
        case 'questions':
          return (0, _lodash.isEmpty)(this.currentQuestion.selectedAnswer);
        case 'business-model':
          return !this.args.isBusinessModelFormComplete;
        default:
          return null;
      }
    }
    removeDescription() {
      const selectedItems = document.getElementsByClassName('ember-power-select-selected-item');
      const selectedItem = selectedItems ? selectedItems[1] : null;
      const description = selectedItem ? selectedItem.querySelector('.business-model-description') : null;
      if (description) {
        description.remove();
      }
    }
    answerQuestion(answer) {
      this._setSelectedAnswer(this.currentQuestion, answer);
      this.questionHistory.addObject(this.currentQuestion);
      this.args.removeBusinessModels(this.currentQuestion.selectedAnswer.valuesToRemove);
      this._setIsAnswered(this.currentQuestion, true);
    }
    goBack() {
      if (this.currentStep === 'business-type') {
        this.args.clearSelectedIndustry();
        return;
      }
      if (this.currentStep === 'questions' && (0, _utils.isPresent)(this.currentQuestion)) {
        this._setSelectedAnswer(this.currentQuestion, null);
      }
      if (this.previousDropdownStep === 'business-type') {
        this.args.chooseBusinessType(null);
      }
      if (this.currentStep === 'business-model' && (0, _utils.isPresent)(this.args.selectedBusinessModel)) {
        this.args.chooseBusinessModel(null);
      }
      if (this.previousDropdownStep === 'questions') {
        this._setSelectedAnswer(this.previousQuestion, null);
        this.args.undoLastRemovedBusinessModels();
        this._setIsAnswered(this.previousQuestion, false);
        this.questionHistory.removeObject(this.previousQuestion || null);
      }
      this.args.trackRedidCategorization();
    }
    _setSelectedAnswer(question, answer) {
      question?.set('selectedAnswer', answer);
    }
    _setIsAnswered(question, isAnswered) {
      question?.set('isAnswered', isAnswered);
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "questionHistory", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: function () {
      return [];
    }
  }), _applyDecoratedDescriptor(_class.prototype, "removeDescription", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "removeDescription"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "answerQuestion", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "answerQuestion"), _class.prototype), _applyDecoratedDescriptor(_class.prototype, "goBack", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "goBack"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, BusinessModelComponent);
});